import z from "zod";
import { looseUuid } from "@thalamos/common";
export const CreateTrustRequestSchema = z.object({
    name: z.string().trim().min(1, "Name is required"),
    address: z.string().trim().min(1, "Address is required"),
    postalCode: z.string().trim().min(1, "Postal code is required"),
    emhaOrgId: looseUuid().optional().nullable(),
    odsCode: z.string().max(255).optional().nullable(),
});
export const UpdateTrustRequestSchema = CreateTrustRequestSchema;
//# sourceMappingURL=trustRequests.js.map